/* eslint-disable max-len */
import React, { Suspense, lazy } from 'react'
import { string } from 'prop-types'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'
import { ALL, PROJECTS, ARTICLES, FOLDERS, PRODUCTS, IMAGES, PROFESSIONALS, GALLERY, ARTICLE_ARCHIVE } from '../utils/constants'
import ErrorBoundary from '../components/error-handling/ErrorBoundaries'
import ScreensResultsProjects from './ResultsProjects'
import { FiltersProvider } from './../providers/filters/filtersContext'
import { GalleryProvider } from '../providers/GalleryProvider'
import Loader from '../components/ui/loader/Loader'

// Components loaded lazily
const ScreensHome = lazy(() => import('./Home'))
const ScreensResultsAll = lazy(() => import('./ResultsAll'))
const ScreensResultsProducts = lazy(() => import('./ResultsProducts'))
const ScreensResultsArticles = lazy(() => import('./ResultsArticles'))
const ScreensResultsFolders = lazy(() => import('./ResultsFolders'))
const ScreensResultsProfessionals = lazy(() => import('./ResultsProfessionals'))
const ScreensResultsImages = lazy(() => import('./ResultsImages'))
const ResultsArticleArchive = lazy(() => import('./ResultsArticleArchive'))
const Gallery = lazy(() => import('./Gallery'))

const availableSitesString = ['us', 'cl', 'mx', 'co', 'pe', 'br', 'cn'].join('|')
const SITE_KEY = ':site?'

const renderWrappedComponent = (props, site, type, Component) => {
  return <FiltersProvider {...props} type={type} >
    <Component {...props} site={site} />
  </FiltersProvider>
}

const renderComponent = (props, site, Component) => <Component {...props} site={site} />

const NavigationSwitch = ({ site }) => {
  const location = useLocation()
  const { background, backgroundProps } = location.state || {}
  return (
    <ErrorBoundary site={site}>
      <GalleryProvider site={site}>
        <Suspense fallback={<Loader fullScreen />}>
          <Switch location={background || location}>
            <Route path={`/${SITE_KEY}/${ALL}`} render={props => renderComponent(props, site, ScreensResultsAll)} />
            <Route path={`/${SITE_KEY}/${ARTICLES}`} render={props => renderComponent(props, site, ScreensResultsArticles)} />
            <Route path={`/${SITE_KEY}/${FOLDERS}`} render={props => renderComponent(props, site, ScreensResultsFolders)} />
            <Route path={`/${SITE_KEY}/${PROJECTS}(/*)`} render={props => renderWrappedComponent(props, site, PROJECTS, ScreensResultsProjects)} />
            <Route path={`/${SITE_KEY}/${PRODUCTS}(/*)`} render={props => renderWrappedComponent(props, site, PRODUCTS, ScreensResultsProducts)} />
            <Route path={`/${SITE_KEY}/${IMAGES}(/*)`} render={props => renderWrappedComponent(props, site, IMAGES, ScreensResultsImages)} />
            <Route path={`/${SITE_KEY}/${PROFESSIONALS}(/*)`} render={props => renderWrappedComponent(props, site, PROFESSIONALS, ScreensResultsProfessionals)} />
            <Route path={`/${SITE_KEY}/${ARTICLE_ARCHIVE}(/*)`} render={props => renderWrappedComponent(props, site, ARTICLE_ARCHIVE, ResultsArticleArchive)} />
            <Route exact path={'/:site(' + availableSitesString + ')?'} render={props => renderComponent(props, site, ScreensHome)} />
          </Switch>
          {/* Modal Route, outside of regular navigation */}
          {background && backgroundProps &&
            <Route path={`/${SITE_KEY}/${GALLERY}/:slug*`} render={() => <Gallery {...backgroundProps} site={site} />} />
          }
        </Suspense>
      </GalleryProvider>
    </ErrorBoundary>
  )
}

const ScreensRouting = props => (
  <BrowserRouter basename='/search'>
    <NavigationSwitch {...props} />
  </BrowserRouter>
)

NavigationSwitch.propTypes = {
  site: string
}

export default ScreensRouting
